/**
 * WhatsNewTour: экскурсия «Что нового» после обновления системы.
 * Автопоказ один раз на человека и выкладку (localStorage), на главном экране, где есть что подсвечивать.
 * Новым сотрудникам не показывается: им хватает вводного обучения. Повтор: кнопка «✨» в меню.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { runSteps } from '@/tour/useTour'
import { WHATS_NEW, whatsNewGroup, whatsNewSeenKey } from '@/tour/whatsNew'
import type { Role } from '@/types'

interface Props {
  userId: string
  role: Role
  autoAllowed: boolean
  forceShow?: boolean
  onClose?: () => void
}

function safeGet(key: string): string | null {
  try { return localStorage.getItem(key) } catch { return null }
}

function safeSet(key: string, value: string): void {
  try { localStorage.setItem(key, value) } catch { /* без localStorage покажем снова, это не страшно */ }
}

export default function WhatsNewTour({ userId, role, autoAllowed, forceShow = false, onClose }: Props) {
  const { pathname } = useLocation()

  useEffect(() => {
    const steps = WHATS_NEW[whatsNewGroup(role)]

    if (forceShow) {
      const t = setTimeout(() => {
        runSteps(steps, { doneBtnText: 'Понятно ✓' })
        onClose?.()
      }, 200)
      return () => clearTimeout(t)
    }

    if (!autoAllowed || pathname !== '/dashboard') return
    const seenKey = whatsNewSeenKey(userId)
    if (safeGet(seenKey)) return

    // Новый сотрудник: вводное обучение ещё не пройдено, «что нового» ему не нужно
    if (!safeGet(`tour_v2_done_${userId}`)) {
      safeSet(seenKey, '1')
      return
    }

    const t = setTimeout(() => {
      const shown = runSteps(steps, {
        doneBtnText: 'Понятно ✓',
        onDestroyed: () => safeSet(seenKey, '1'),
      })
      if (!shown) safeSet(seenKey, '1')
    }, 1800)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, role, autoAllowed, forceShow, pathname])

  return null
}
